import React from 'react';
import { RouteConfig } from 'react-router-config';
import { BrowserRouter } from 'react-router-dom';
// import { Layout } from 'antd';
import RichRoutes from '@shared/utils/router/rich-routes';
// import CommonHeader from '@shared/components/header';
// import Sider from '@shared/components/sider';
// import BreadcrumbWrapper from '@shared/components/breadcrumb';
import pageDefaultLoading from '@shared/components/loading/page-loading';
// import routeConfig from '@shared/config/routerAuth';
// import route from './routes';

// const { Content } = Layout;

const App: React.FC<{ route: RouteConfig | RouteConfig[] }> = ({ route }) => {
    // const handleClick = () => {
    //     console.log('switch');
    // };
    // const pathSnippets = location.pathname.split('/').filter(i => i);
    // const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    //     const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
    //     return (
    //         <Breadcrumb.Item key={url}>
    //             <Link to={url}>{breadcrumbNameMap[url]}</Link>
    //         </Breadcrumb.Item>
    //     );
    // });

    return (
        <React.Suspense fallback={pageDefaultLoading}>
            <BrowserRouter>
                {/* <CommonHeader />
            <Layout className="gordon-layout">
                <BrowserRouter>
                    <Sider routeAuthConfig={routeConfig} />
                    <Content className="gordon-main-container">
                        <BreadcrumbWrapper /> */}
                <RichRoutes route={route} />
                {/* </Content>
                
            </Layout> */}
            </BrowserRouter>
        </React.Suspense>
    );
};

export default App;
